import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "bypassSecurityTrustHtml", pure: false })
export class BypassSecurityTrustHtml implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/bypass-security-trust-html.pipe.ts